import { useSelector } from 'react-redux';

export const usePermissions = () => {
  const { accessibility } = useSelector((state) => state?.shop);
  return accessibility?.permissions;
};
